export const GENERIC_ERROR_MESSAGE = 'En este momento no podemos procesar la solicitud, intente más tarde';
